/**
 * Semantic UI Dropdown
 * @see {@link https://semantic-ui.com/modules/dropdown.html}
 * Для работы необходимо реализовать подобную схему:
 * <div class="excluding-dropdown-group-container">
 *
 *     <input type="hidden" class="excluding-dropdown-input">
 *
 *     <div class="ui search selection dropdown excluding-dropdown">
 *     ... Здесь значения согласно документации
 *     </div>
 *
 *     <div class="ui fluid search labeled selection dropdown excluding-dropdown">
 *     ... Здесь значения согласно документации
 *     </div>
 *
 *     <div class="ui fluid search labeled selection dropdown excluding-dropdown">
 *     ... Здесь значения согласно документации
 *     </div>
 *
 *     ...
 *
 * </div>
 *
 * Выбранное значение будет записываться в поле '.excluding-dropdown-input'
 */
var config = {
    parentContainerSelector: '.excluding-dropdown-group-container',
    inputSelector: '.excluding-dropdown-input'
};
// Вызов нажатия на элемент списка при нажатии на Enter в открытом списке.
// В первую очередь -- чтобы можно было проверить открытость списка
$('.ui.dropdown.excluding-dropdown').on('keydown', function(e){
    if ((e.keyCode || e.which) === $.fn.dropdown.settings.keys.enter) {
        var $this = $(this);
        if ($this.dropdown('is active')) {
            $this.dropdown('get item').trigger('click');
        }
    }
})
// Собственно список
.dropdown({
    fullTextSearch: 'exact',
    onChange: function(value, text, $choice) {
        var $this = $(this),
            $parentContainer = $this.closest(config.parentContainerSelector);
        if ($parentContainer.length) {
            $parentContainer.find('.ui.dropdown.excluding-dropdown').not($this).dropdown('restore placeholder text').dropdown('restore default value');
            var $input = $parentContainer.find('input' + config.inputSelector);
            if ($input.length) {
                $input.val(value);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./assets/javascript/semantic-ui_excluding_dropdown.js